import { useCallback } from "react";
import { requestCommunityNewsData, parseDataFields, getMapImage } from "../../services/requestCommunityNews";
import {logToClientLogger} from "../../helpers/clientLogger";

// Track if a request is already in progress for a specific projectId
const pendingRequests = {};

export function useQueryCommunityNews({state, dispatch}) {
  const { communityNews, childInfo } = state;

  // Project Call Depends On The ChildData Call
  if (childInfo.status === "error" && communityNews.status !== "error") {
    dispatch({type: "setCommunityNewsStatus", payload: "error"});
  }

  const request = useCallback(async (projectId) => {
    if (!projectId) {
      throw new Error("project id is not available");
    }

    // If data is already loaded successfully, return it
    if (communityNews.status === "success") {
      return communityNews.data;
    }

    // If another component is already loading the same projectId, wait for that request
    if (pendingRequests[projectId]) {
      return pendingRequests[projectId];
    }

    dispatch({type: "setCommunityNewsStatus", payload: "loading"});
    
    // Create the promise and store it in pendingRequests
    const requestPromise = (async () => {
      try {
        // This function will now check sessionStorage internally
        const data = await requestCommunityNewsData(projectId);
        dispatch({type: "setCommunityNewsData", payload: data});
        dispatch({type: "setCommunityNewsStatus", payload: "success"});
        return data;
      } catch (err) {
        dispatch({type: "setCommunityNewsStatus", payload: "error"});
        console.log(err);
        logToClientLogger(err);
        throw err;
      } finally {
        // Remove the reference to this request when done
        delete pendingRequests[projectId];
      }
    })();

    // Store the promise for other components to use
    pendingRequests[projectId] = requestPromise;
    
    return requestPromise;
  }, [dispatch, communityNews]);

  return {
    ...communityNews,
    request,
    getMapImage,
    parseDataFields,
    isPending: communityNews.status === "pending",
    isLoading: communityNews.status === "loading",
    isWaiting: ["loading", "pending"].includes(communityNews.status),
    isError: communityNews.status === "error",
    isSuccess: communityNews.status === "success",
    isComplete: ["success", "error"].includes(communityNews.status)
  }
}

export default useQueryCommunityNews;